import {
  GamoraControllerStateArgs,
  GamoraControllerStateMap,
} from '@ver.id/libs.internal.gamora';
import { HoruzError } from '../../../../errors/error.js';
import { HoruzProtocolChulakErrorProtocolUnknown } from '../../errors/index.js';
import { HoruzProtocolChulakServerStateContext } from '../context.js';
import { HoruzProtocolChulakStateBase } from '../base.js';
import { IHoruz } from '../../../../horuz.js';

/**
 * HoruzProtocolChulakServerState
 *
 * Abstract class that represents the state node
 * @internal
 */
export class HoruzProtocolChulakServerStateBase<
  TStateMap extends GamoraControllerStateMap,
  TStateContext extends HoruzProtocolChulakServerStateContext,
  TRoot extends IHoruz,
> extends HoruzProtocolChulakStateBase<TStateMap, TStateContext, TRoot> {
  constructor(args: GamoraControllerStateArgs) {
    super(args);
  }

  /**
   * Get service
   */
  get serviceController() {
    return this.$root.$('protocols').$('chulak').$('service');
  }

  /**
   * Gets store
   */
  get serverSessionStore() {
    return this.$root.$('protocols').$('chulak').$('store').$('serverSession');
  }

  /**
   * Gets store
   */
  get serviceSessionStore() {
    return this.$root.$('protocols').$('chulak').$('store').$('serviceSession');
  }

  /**
   * Try to handle exception
   * @param stateContext
   */
  protected _tryHandleException(
    serverStateContext: TStateContext,
    error?: unknown,
  ) {
    if (
      this.$isInCurrentState(serverStateContext) &&
      !this.$hasPostedTransition(serverStateContext)
    ) {
      this._trySetLastError(serverStateContext, {
        error: error,
        forceError: true,
      });
      this.$postTransition(serverStateContext, { stateNext: 'Close' });
    }
  }

  /**
   * Try to set last error
   * @param stateContext
   */
  protected _trySetLastError = (
    serverStateContext: TStateContext,
    input: { error?: unknown; forceError: boolean },
  ) => {
    // Force error
    if (input.forceError) {
      serverStateContext.stateContextRegistry.lastError =
        HoruzProtocolChulakErrorProtocolUnknown.Create();
    }

    // Set user error
    if (input.error instanceof HoruzError) {
      serverStateContext.stateContextRegistry.lastError = input.error;
    }
  };
}
